export var isItemWithSublist = function isItemWithSublist(item) {
  return item.listItem !== undefined;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/list/dist/esm/shared.js
// module id = 1396
// module chunks = 11